import * as components from './components'

export default [
  {
    path: '/advisor/tracker',
    component: components.AdviseeTracker,
    name: 'adviseeTracker',
    props: true
  },
  {
    path: '/learner/home/:uuid',
    component: components.AdvisorLearnerHomePage,
    name: 'learnerHomePage',
    props: true
  },
  {
    path: '/learner/profile/:uuid',
    component: components.AdvisorLearnerProfilePage,
    name: 'learnerProfilePage',
    props: true
  },
  {
    path: '/advisor/upload',
    component: components.AdviseeAdvisorUpload,
    name: 'adviseeAdvisorUpload',
    props: true
  },
  {
    path: '/recruiter/tracker',
    component: components.AdviseeTracker,
    name: 'prospectiveStudentTracker',
    props: true
  },
  {
    path: '/instructor/advisee/tracker',
    component: components.InstructorAdviseeTracker,
    name: 'instructorAdviseeTracker',
    props: true
  },
  {
    path: '/calendar/list',
    component: components.CalendarEventList,
    name: 'calendarEventList',
    props: true
  },
  {
    path: '/calendar/list/:userUuid',
    component: components.CalendarEventList,
    name: 'adviseeCalendarEventList',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/adviseeTracker/routes.js